import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractLitigationCaseTransformations from "./abstractLitigationCaseTransformations";

const employmentContractTransformations: FormTransformations = {
  dateFields: [
    ...abstractLitigationCaseTransformations.dateFields!,
    { path: "client.birthDate", type: "date" },
    { path: "employmentStartDate", type: "date" },
    { path: "employmentEndDate", type: "date" },
    { path: "salaryOutstandingStartDate", type: "date" },
    { path: "salaryOutstandingEndDate", type: "date" },
    { path: "overtimeAccumulatedStartDate", type: "date" },
    { path: "overtimeAccumulatedEndDate", type: "date" },
    { path: "workCertificateReceivedAtDate", type: "date" },
    { path: "parentalLeaveStartDate", type: "date" },
    { path: "parentalLeaveEndDate", type: "date" },
    { path: "partTimeStartDate", type: "date" },
    { path: "incidentStartDate", type: "date" },
    { path: "allegedDamageDate", type: "date" },
    { path: "writtenWarningReceivedDate", type: "date" },
    { path: "terminationAgreementOfferDate", type: "date" },
    { path: "terminationAgreementDeadlineDate", type: "date" },
  ],
  numberFields: [...abstractLitigationCaseTransformations.numberFields!, "numberOfEmployees", "yearOfVacationClaim"],
  timeFields: abstractLitigationCaseTransformations.timeFields,
  floatFields: [
    ...abstractLitigationCaseTransformations.floatFields!,
    "grossSalary",
    "grossSalarySumLastThreeMonths",
    "overtimeAccumulatedTotal",
    "weeklyWorkingHours",
    "vacationDaysLeft",
    "hoursLeisureCompensation",
    "partTimeDesiredWeeklyWorkingHours",
    "offeredSettlementPayment",
    "grossSalaryClaim",
    "grossSalaryClaimFromOvertime",
    "grossSalaryClaimFromVacationDays",
  ],
  ibanFields: abstractLitigationCaseTransformations.ibanFields!,
  entityIriFields: abstractLitigationCaseTransformations.entityIriFields,
};

export default employmentContractTransformations;
